"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhoneNumberByType = exports.getPhoneNumber = void 0;
/**
 * Returns phone number from InnovaClienteData object
 *
 * @param clientData - InnovaClienteData object
 */
function getPhoneNumber(clientData) {
    if (!clientData.phoneGroup) {
        return '';
    }
    var phoneFound = clientData.phoneGroup.find(function (_a) {
        var number = _a.number;
        return number !== '';
    });
    if (typeof phoneFound === 'undefined') {
        return '';
    }
    return phoneFound.number;
}
exports.getPhoneNumber = getPhoneNumber;
/**
 * Returns phone number from InnovaClienteData object by type
 *
 * @param clientData - InnovaClienteData object
 */
function getPhoneNumberByType(clientData, phoneNumberType) {
    if (!clientData.phoneGroup) {
        return '';
    }
    var phoneFound = clientData.phoneGroup.find(function (_a) {
        var type = _a.type;
        return type === phoneNumberType;
    });
    if (typeof phoneFound === 'undefined') {
        return '';
    }
    return phoneFound.number;
}
exports.getPhoneNumberByType = getPhoneNumberByType;
//# sourceMappingURL=personDataMethods.js.map